import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Check, Calendar } from 'lucide-react';
import {
  BRAND_NESTED_PANEL,
  BRAND_PRIMARY_BTN_CLASS,
  BRAND_SELECTED_TOGGLE_CLASS,
  DASHBOARD_FILTER_INPUT,
  DASHBOARD_TAB_INACTIVE,
} from '@/constants/brandColors';
import { cn } from '@/lib/utils';

const toggleClass = (active) =>
  cn(
    'px-3 py-1.5 rounded-full text-sm font-normal transition-all border',
    active ? BRAND_SELECTED_TOGGLE_CLASS : DASHBOARD_TAB_INACTIVE,
  );

export default function FlexibleDateSelector({ month, travelDuration, onMonthChange, onTravelDurationChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const months = [
    { value: '0', label: 'Next 6 months' },
    { value: '12', label: 'December' },
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' }
  ];

  const durations = [
    { value: '1', label: 'Weekend' },
    { value: '2', label: '1 week' },
    { value: '3', label: '2 weeks' }
  ];

  const selectedMonth = months.find(m => m.value === month) || months[0];
  const selectedDuration = durations.find(d => d.value === travelDuration) || durations[1];

  const summaryText = `${selectedDuration.label} trip in ${selectedMonth.label.toLowerCase()}`;

  return (
    <div className="space-y-3">
      <Button
        type="button"
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          'w-full justify-start text-left font-normal rounded-full',
          DASHBOARD_FILTER_INPUT,
          'hover:bg-brand-900/50',
        )}
      >
        <Calendar className="mr-2 h-4 w-4" />
        {summaryText}
      </Button>

      {isOpen && (
        <div className={cn(BRAND_NESTED_PANEL, 'p-4 space-y-4')}>
          <div>
            <label className="text-xs text-white/60 mb-2 block">Travel Month</label>
            <div className="flex flex-wrap gap-2">
              {months.map((m) => (
                <button
                  key={m.value}
                  type="button"
                  onClick={() => onMonthChange(m.value)}
                  className={toggleClass(month === m.value)}
                >
                  {month === m.value && <Check className="w-3 h-3 inline mr-1" />}
                  {m.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs text-white/60 mb-2 block">Trip Duration</label>
            <div className="flex gap-2">
              {durations.map((d) => (
                <button
                  key={d.value}
                  type="button"
                  onClick={() => onTravelDurationChange(d.value)}
                  className={cn(toggleClass(travelDuration === d.value), 'flex-1')}
                >
                  {travelDuration === d.value && <Check className="w-3 h-3 inline mr-1" />}
                  {d.label}
                </button>
              ))}
            </div>
          </div>

          <Button
            type="button"
            onClick={() => setIsOpen(false)}
            className={cn('w-full rounded-full', BRAND_PRIMARY_BTN_CLASS)}
          >
            Done
          </Button>
        </div>
      )}
    </div>
  );
}
